import IdForm from './IdForm'
import Completed from './Completed'
import OTPForm from './OTPForm'
import ResetPasswordForm from './ResetPasswordForm'

export { IdForm, Completed, OTPForm, ResetPasswordForm }
